<template>
  <Bar id="my-chart-bar-percentage" :options="chartOptions" :data="chartData" :style="styles" />
</template>

<script>
import { Bar } from "vue-chartjs";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { floatingLabels } from "./nossoPlugin.js";

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
} from "chart.js";

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
  ChartDataLabels,
  floatingLabels
);



export default {
  name: "BarChart1",
  components: {
    Bar,
  },
  props: {
    chartId: {
      type: String,
      default: 'pie-chart'
    },
    datasetIdKey: {
      type: String,
      default: 'label'
    },
    width: {
      type: Number,
      default: 600
    },
    height: {
      type: Number,
      default: 600
    },
    cssClasses: {
      default: '',
      type: String
    },
    styles: {
      type: Object,
      default: () => {
        return {minHeight: "350px",}
      }
    },
  }, 
  data() {
    return {
      chartData: {
        type: "bar",
        labels: [
          ["Serviços", "Digitais"],
          ["Usuários", "gerais"],
          ["TV aberta"],
          ["TV paga"],
          ["Shows e", "eventos", "ao vivo"],
          ["Rádio"],
          ["Cinema"],
        ],
        datasets: [
          {
            label: "2021",
            data: [
              252044630, 218708220, 253274663, 194691852, 45491821, 114153553,
              8071412,
            ],
            backgroundColor: "rgba(139, 197, 63, 0.2)",
            hoverBackgroundColor: "rgba(139, 197, 63, 0.4)",
            hoverBorderWidth: 0,
            barPercentage: 0.8,
            datalabels: {
              display: false,
            },
          },
          {
            label: "2022",
            data: [
              318002800, 285943789, 261205866, 191275392, 186296216, 132263564,
              18778042,
            ],
            backgroundColor: "rgba(139, 197, 63, 0.5)",
            hoverBackgroundColor: "rgba(139, 197, 63, 1)",
            hoverBorderWidth: 0,
            barPercentage: 0.8,
            datalabels: {
              display: false,
            },
          },
        ],
      },

      chartOptions: {
        // indexAxis: "y",
        plugins: {
          tooltip: {
            displayColors: true,
            backgroundColor: "#FFF",
            bodyColor: "#000",
            titleColor: " #000",
            padding: 10,
            callbacks: {
              title: (ctx) => ctx[0].label.replaceAll(",", " "),
              label: (x) => {
                // console.log(x);
                return `${x.dataset.label}: R$${x.formattedValue}`;
              },
            },
          },
          legends: { display: false },
          customDataLabels: { enable: true },
        },
        animation: {
          duration: 4000,
          // easing: 'easeInOutBounce',
        },
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          x: {
            grid: {
              display: false,
            },
            // position: "top",
          },
          y: {
            grace: 1,
            grid: {
              display: true,
            },
            border: {
              display: false,
            },
            ticks: {
              callback: function (value) {
                return value == 0 ? 0 : value / 1000000 + "M";
              },
            },
          },
        },
      },
      plugins: [ floatingLabels],
    };
  },
};
</script>
